<template>
  <div class="h-[calc(100vh-82px)] flex flex-col">
    <!-- 第一步：表单填写 -->
    <div
      class="flex flex-1 bg-gray-50 overflow-hidden"
      v-show="currentCreateStep == 1"
    >
      <!-- 左侧步骤条 -->
      <div class="w-64 bg-white shadow-sm p-6 overflow-y-auto">
        <el-steps
          direction="vertical"
          :active="activeStep"
        >
          <el-step
            v-for="(step, index) in steps"
            :key="index"
            :title="step.title"
            :status="getStepStatus(index)"
            class="cursor-pointer"
            @click.native="scrollToSection(step.id, index)"
          >
            <template #title>
              <div>
                <span>{{ step.title }}</span>
                <div
                  v-if="step.errors.length > 0"
                  class="text-red-500 text-xs mt-1"
                >
                  <div
                    v-for="error in step.errors"
                    :key="error"
                    class="truncate"
                  >
                    {{ error }}
                  </div>
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>

      <!-- 右侧内容区域 -->
      <div class="flex-1 flex flex-col overflow-hidden border-l">
        <div
          class="flex-1 p-6 overflow-y-auto"
          ref="contentArea"
          v-loading="previewLoading"
        >
          <div
            class="max-w-[1200px] mx-auto pb-4"
            style="max-width: 1200px"
          >
            <div
              v-for="(step, index) in steps"
              :key="step.id"
              :id="step.id"
            >
              <el-collapse
                v-model="activeCollapse"
                @change="handleCollapseChange"
              >
                <el-collapse-item
                  :title="step.title"
                  :name="step.name"
                >
                  <template slot="title">
                    <div class="pl-[20px] text-[14px] font-bold">{{ step.title }}</div>
                  </template>
                  <div class="content">
                    <!-- 投放目标 -->
                    <CampaignTarget
                      v-if="step.name === 'target'"
                      ref="targetComponent"
                      v-model="formData.type"
                      :enumConstants="enumConstants"
                      :createAdAccount="createAdAccount"
                    />
                    <!-- 投放链接 -->
                    <PromotionLink
                      v-if="step.name === 'link'"
                      ref="linkComponent"
                      :value="{ promoteInfo: formData.promoteInfo, campaignTraceConfig: formData.campaignTraceConfig }"
                      @input="handlePromotionLinkChange"
                      @oneClickFill="handleOneClickFill"
                      :enumConstants="enumConstants"
                      :createAdAccount="createAdAccount"
                    />
                    <!-- 预算出价 -->
                    <BudgetBidding
                      v-if="step.name === 'budget'"
                      ref="budgetComponent"
                      :value="{
                        bidAmount: formData.bidAmount,
                        bidStrategy: formData.bidStrategy,
                        budgetAmount: formData.budgetAmount,
                        budgetType: formData.budgetType,
                        startDate: formData.startDate,
                      }"
                      @input="handleBudgetChange"
                      :enumConstants="enumConstants"
                      :createAdAccount="createAdAccount"
                    />
                    <!-- 广告系列 -->
                    <AdCampaign
                      v-if="step.name === 'campaign'"
                      ref="campaignComponent"
                      v-model="formData.campaignCriterion"
                      :enumConstants="enumConstants"
                      :createAdAccount="createAdAccount"
                      :bigData="formData"
                    />
                    <!-- 关键字 -->
                    <Keywords
                      v-if="step.name === 'keywords'"
                      ref="keywordsComponent"
                      v-model="formData.adGroupOptions[0].groupCriterion"
                      :enumConstants="enumConstants"
                      :bigData="formData"
                      :createAdAccount="createAdAccount"
                    />
                    <!-- 广告创意 -->
                    <AdCreative
                      v-if="step.name === 'creative'"
                      ref="creativeComponent"
                      v-model="formData.adOptions[0]"
                      :keywordList="formData.adGroupOptions[0].groupCriterion.keywordList"
                      :enumConstants="enumConstants"
                      :createAdAccount="createAdAccount"
                    />
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
        <!-- 固定在底部的按钮 -->
        <!-- <div class="bg-white border-t p-4 text-right">
          
        </div> -->
      </div>
    </div>

    <!-- 第二步：预览 -->
    <div
      class="flex flex-col flex-1 bg-gray-50 overflow-hidden"
      v-show="currentCreateStep == 2"
    >
      <div class="flex-1 overflow-y-auto p-6">
        <Preview
          ref="preview"
          :previewData="previewData"
          :enumConstants="enumConstants"
          :createAdAccount="createAdAccount"
          @setBidMsg="handleBudgetChange"
          @update:previewData="previewData = $event"
        />
      </div>
    </div>
    <!-- 固定在底部的按钮 -->
    <div class="bg-white border-t p-4 flex justify-between">
      <div>
        <el-button
          type="primary"
          size="small"
          @click="exit"
          >退出</el-button
        >
      </div>
      <div class="text-right">
        <el-button
          type="primary"
          size="small"
          :disabled="previewLoading"
          v-if="currentCreateStep == 1"
          @click="submitForm"
          >下一步</el-button
        >
        <span v-else>
          <el-button
            type="primary"
            size="small"
            @click="currentCreateStep--"
          >
            上一步
          </el-button>

          <el-button
            type="primary"
            size="small"
            @click="createCampaign"
            >提交</el-button
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignTarget from './components/CampaignTarget.vue';
import PromotionLink from './components/PromotionLink.vue';
import BudgetBidding from './components/BudgetBidding.vue';
import AdCampaign from './components/AdCampaign.vue';
import Keywords from './components/Keywords.vue';
import AdCreative from './components/AdCreative.vue';
import Preview from './components/Preview.vue';
import { budgetTypes } from '@/views/google/create/index';
import { searchBidStrategy } from './index';
import { mapState } from 'vuex';

import { adConstMapGG, createSearchCampaign, preview, createStash, getStash } from '@/api/google/create';
export default {
  name: 'CreateSearchAds',
  components: {
    CampaignTarget,
    PromotionLink,
    BudgetBidding,
    AdCampaign,
    Keywords,
    AdCreative,
    Preview,
  },
  data() {
    return {
      activeStep: 1,
      currentCreateStep: 1,
      activeCollapse: 'link',
      steps: [
        {
          id: 'target-section',
          title: '投放目标',
          name: 'target',
          component: 'CampaignTarget',
          status: 'wait',
          ref: 'targetComponent',
          errors: [],
        },
        {
          id: 'link-section',
          title: '投放链接',
          name: 'link',
          component: 'PromotionLink',
          status: 'wait',
          ref: 'linkComponent',
          errors: [],
        },
        {
          id: 'budget-section',
          title: '预算出价',
          name: 'budget',
          component: 'BudgetBidding',
          status: 'wait',
          ref: 'budgetComponent',
          errors: [],
        },
        {
          id: 'campaign-section',
          title: '广告系列',
          name: 'campaign',
          component: 'AdCampaign',
          status: 'wait',
          ref: 'campaignComponent',
          errors: [],
        },
        {
          id: 'keywords-section',
          title: '关键字',
          name: 'keywords',
          component: 'Keywords',
          status: 'wait',
          ref: 'keywordsComponent',
          errors: [],
        },
        {
          id: 'creative-section',
          title: '广告创意',
          name: 'creative',
          component: 'AdCreative',
          status: 'wait',
          ref: 'creativeComponent',
          errors: [],
        },
      ],
      enumConstants: {
        countries: [],
        languages: [],
        budgetTypes,
        searchBidStrategy,
      },
      previewLoading: false,
      formData: {
        name: '',
        type: 'SEARCH',
        promoteInfo: {},
        campaignTraceConfig: null,
        accountId: '',
        accountName: '',
        bidAmount: null,
        bidStrategy: 'MAX_CONVERSION',
        budgetAmount: 5,
        budgetType: 'DAILY',
        startDate: null,
        status: 'ENABLED',
        campaignCriterion: {
          target: {
            locations: [],
            excludeLocations: [],
            languages: [],
          },
          geoTargetType: 'PRESENCE_OR_INTEREST',
        },
        adGroupOptions: [
          {
            campaignBidStrategy: 'MAX_CONVERSION',
            campaignBidAmount: null,
            groupCriterion: {
              keywordList: [],
            },
            status: 'ENABLED',
          },
        ],
        adOptions: [
          {
            descriptions: [],
            headlines: [],
            status: 'ENABLED',
            type: 'RESPONSIVE_SEARCH_AD',
          },
        ],
      },
      previewData: {},
    };
  },
  created() {
    this.$store.dispatch('app/closeSideBar');
    this.getEnumConstants();
  },
  computed: {
    ...mapState('google', ['createAdAccount']),
  },
  methods: {
    // 保存创建数据的缓存
    saveCreateStash() {
      createStash({ stashInfo: JSON.stringify(this.formData), accountId: this.createAdAccount.id, type: 'SEARCH' });
    },

    // 获取创建广告的数据缓存
    async getCreateStash() {
      try {
        const res = await getStash({ accountId: this.createAdAccount.id, type: 'SEARCH' });
        if (res.code == 0) {
          if (res.data) {
            this.$confirm('是否使用上次缓存数据？', '提示', {
              confirmButtonText: '使用',
              cancelButtonText: '取消',
              type: 'info',
            }).then(() => {
              this.formData = JSON.parse(res.data.stashInfo);
              console.log('恢复缓存数据:', this.formData);
              // 确保数据更新后触发子组件重新初始化
              this.$nextTick(() => {
                // 强制更新所有子组件
                this.$forceUpdate();
              });
            });
          }
        }
      } catch {}
    },
    getEnumConstants() {
      this.loading = true;
      adConstMapGG()
        .then((res) => {
          if (res.code == 0) {
            this.enumConstants.countries = res.data.defaultCountries;
            this.enumConstants.languages = res.data.defaultLanguages;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    scrollToSection(sectionId, stepIndex) {
      const element = document.getElementById(sectionId);
      if (element) {
        this.$refs.contentArea.scrollTo({
          top: element.offsetTop - 20,
          behavior: 'smooth',
        });
        this.activeStep = stepIndex;
        // 展开对应的折叠面板
        this.activeCollapse = this.steps[stepIndex].name;
      }
    },
    handleScroll() {
      const scrollTop = this.$refs.contentArea.scrollTop;
      const sections = this.steps.map((step) => ({
        id: step.id,
        element: document.getElementById(step.id),
      }));

      let currentStep = 0;
      sections.forEach((section, index) => {
        if (section.element && section.element.offsetTop - 100 <= scrollTop) {
          currentStep = index;
        }
      });

      this.activeStep = currentStep;
    },
    handleCollapseChange(activeNames) {
      if (activeNames) {
        const stepIndex = this.steps.findIndex((step) => step.name === activeNames[activeNames.length - 1]);
        if (stepIndex !== -1) {
          this.activeStep = stepIndex;
        }
      }
    },
    confirmStep(stepIndex) {
      this.$set(this.steps[stepIndex], 'status', 'success');
      this.$message.success(`${this.steps[stepIndex].title}已确认`);
    },
    getStepStatus(index) {
      if (this.steps[index].errors.length > 0) {
        return 'error';
      }
      if (this.steps[index].status === 'success') {
        return 'success';
      }
      if (index === this.activeStep) {
        return 'process';
      }
      return this.steps[index].status;
    },
    handlePromotionLinkChange(data) {
      this.formData.promoteInfo = data.promoteInfo || {};
      this.formData.campaignTraceConfig = data.campaignTraceConfig || null;
      this.updateName();
    },
    // 一键投放回填数据
    handleOneClickFill(data) {
      // 回填基础信息
      if (data.name) this.formData.name = data.name;
      if (data.type) this.formData.type = data.type;
      if (data.status) this.formData.status = data.status;

      // 回填投放链接相关信息
      if (data.promoteInfo) {
        const sale = data.promoteInfo.sale;
        const site = data.promoteInfo.site;
        this.formData.promoteInfo = {
          promotionLink: data.promoteInfo.promotionLink || '',
          sale: sale ? { ...sale, id: sale.saleId } : null,
          site: site ? { ...site, name: site.domain } : null,
          utmSourceConfig: data.promoteInfo.utmSourceConfig || '',
        };
      }

      // 回填预算出价信息
      if (data.bidAmount !== undefined) this.formData.bidAmount = data.bidAmount;
      if (data.bidStrategy) this.formData.bidStrategy = data.bidStrategy;
      if (data.budgetAmount !== undefined) this.formData.budgetAmount = data.budgetAmount;
      if (data.budgetType) this.formData.budgetType = data.budgetType;
      if (data.startDate) this.formData.startDate = data.startDate;

      // 回填广告系列定向信息
      if (data.campaignCriterion && data.campaignCriterion.target) {
        // 转换地区数据格式，匹配 enumConstants.countries 的结构
        let locations = [];
        if (data.campaignCriterion.target.locations && data.campaignCriterion.target.locations.length > 0) {
          locations = data.campaignCriterion.target.locations
            .map((loc) => {
              // 通过 id 或 code 在 enumConstants.countries 中查找匹配的地区
              const matched = this.enumConstants.countries.find(
                (c) => c.criteria_id === loc.id || c.country_code === loc.code || c.country_code === loc.countryCode,
              );
              return matched || null;
            })
            .filter(Boolean);
        }

        this.formData.campaignCriterion = {
          target: {
            locations: locations,
            excludeLocations: data.campaignCriterion.target.excludeLocations || [],
            languages: data.campaignCriterion.target.languages || [],
          },
          geoTargetType: data.geoTargetType || 'PRESENCE_OR_INTEREST',
        };
      }

      // 回填网络设置
      if (data.networkSettings) {
        this.formData.networkSettings = data.networkSettings;
      }

      // 回填关键字信息
      if (data.adGroupOptions && data.adGroupOptions.length > 0) {
        const adGroupOption = data.adGroupOptions[0];
        this.formData.adGroupOptions[0] = {
          ...this.formData.adGroupOptions[0],
          groupCriterion: {
            keywordList: adGroupOption.groupCriterion?.keywordList || [],
          },
          status: adGroupOption.status || 'ENABLED',
        };
      }

      // 回填广告创意信息
      if (data.adOptions && data.adOptions.length > 0) {
        const adOption = data.adOptions[0];
        this.formData.adOptions[0] = {
          descriptions: adOption.descriptions || [],
          headlines: adOption.headlines || [],
          status: adOption.status || 'ENABLED',
          type: adOption.type || 'RESPONSIVE_SEARCH_AD',
        };
      }

      // 同步广告组的出价策略
      this.formData.adGroupOptions[0].campaignBidStrategy = this.formData.bidStrategy;
      this.formData.adGroupOptions[0].campaignBidAmount = this.formData.bidAmount;

      // 强制更新视图
      this.$forceUpdate();
      this.$message.success('数据回填成功');
    },
    handleBudgetChange(data) {
      this.$nextTick(() => {
        this.formData.bidAmount = data.bidAmount;
        this.formData.bidStrategy = data.bidStrategy;
        this.formData.budgetAmount = data.budgetAmount;
        this.formData.budgetType = data.budgetType;
        this.formData.startDate = data.startDate;
        this.formData.adGroupOptions[0].campaignBidStrategy = data.bidStrategy;
        this.formData.adGroupOptions[0].campaignBidAmount = data.bidAmount;

        // 同步更新previewData以保持数据一致性
        if (this.previewData && Object.keys(this.previewData).length > 0) {
          this.previewData = {
            ...this.previewData,
            bidAmount: data.bidAmount,
            bidStrategy: data.bidStrategy,
            budgetAmount: data.budgetAmount,
            budgetType: data.budgetType,
            startDate: data.startDate,
          };
        }
      });
    },
    updateName() {
      if (this.formData.promoteInfo.sale) {
        this.formData.name = `${this.formData.promoteInfo.sale.saleId}#${this.formData.promoteInfo.sale.productName}#${
          new Date().toISOString().split('T')[0]
        }`;
      }
    },
    exit() {
      this.$router.push({
        name: 'googleAd',
        query: {
          ...this.$route.query,
        },
      });
    },
    beforeRouteLeave(to, form, next) {
      this.$confirm('确定关闭当前创建广告页面吗', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then((res) => {
          this.saveCreateStash();
          this.$store.dispatch('app/openSideBar');
          next();
        })
        .catch(() => {
          next(false);
        });
    },
    async submitForm() {
      this.saveCreateStash();
      // 清空之前的错误信息
      this.steps.forEach((step) => {
        step.errors = [];
        step.status = 'wait';
      });

      let hasErrors = false;

      // 逐个验证每个步骤
      for (let i = 0; i < this.steps.length; i++) {
        const step = this.steps[i];
        const component =
          this.$refs[step.ref] && this.$refs[step.ref][0] ? this.$refs[step.ref][0] : this.$refs[step.ref];

        if (component && typeof component.validate === 'function') {
          try {
            await component.validate();
            this.$set(step, 'status', 'success');
          } catch (errors) {
            hasErrors = true;
            this.$set(step, 'status', 'error');
            this.$set(step, 'errors', [
              ...new Set(Array.isArray(errors) ? errors : [errors?.message || errors || '验证失败']),
            ]);
            console.log(step, 'stepstepstepstep');
            // 同时触发组件内部表单验证显示
            if (component.$refs && component.$refs.form && component.$refs.form.validate) {
              component.$refs.form.validate(() => {});
            }
          }
        } else {
          hasErrors = true;
          this.$set(step, 'status', 'error');
          this.$set(step, 'errors', ['请完成此步骤']);
        }
      }

      if (hasErrors) {
        this.$message.error('请完善表单信息后再提交');
        // 滚动到第一个有错误的步骤
        const firstErrorStep = this.steps.findIndex((step) => step.status === 'error');
        if (firstErrorStep !== -1) {
          this.scrollToSection(this.steps[firstErrorStep].id, firstErrorStep);
        }
        return;
      }

      // 所有验证通过，提交表单
      this.formData.accountId = this.createAdAccount.id;
      this.formData.accountName = this.createAdAccount.name;
      this.formData.geoTargetType = this.formData.campaignCriterion.geoTargetType;
      console.log('最终提交数据:', this.formData);
      // this.$message.success('提交成功');
      try {
        let params = JSON.parse(JSON.stringify(this.formData));
        params.campaignCriterion.target.locations = params.campaignCriterion.target.locations.map((item) => {
          return {
            id: item.criteria_id,
            name: item.name,
            code: item.country_code,
          };
        });
        this.previewLoading = true;
        const res = await preview(params);
        //
        this.previewLoading = false;
        this.previewData = res.data;
        this.currentCreateStep = 2;

        // 清空AdCreative组件的空输入框
        this.$nextTick(() => {
          const creativeComponent =
            this.$refs.creativeComponent && this.$refs.creativeComponent[0]
              ? this.$refs.creativeComponent[0]
              : this.$refs.creativeComponent;
          if (creativeComponent && creativeComponent.clearEmptyInputs) {
            creativeComponent.clearEmptyInputs();
          }
        });
      } catch {
        this.previewLoading = false;
      }
    },
    // 提交
    createCampaign() {
      // 确保previewData包含最新的formData数据
      this.previewData = {
        ...this.formData,
        ...this.previewData,
      };
      console.log(this.previewData, 'previewData');
      this.$refs.preview.createCampaign();
    },
  },
  mounted() {
    this.getCreateStash();
  },
};
</script>

<style scoped lang="scss">
.el-steps {
  background: transparent;
}

.el-step {
  cursor: pointer;
}

.el-step:hover .el-step__title {
  color: #409eff;
}

.el-collapse {
  border: none;
}

.el-collapse-item {
  margin-bottom: 16px;
  overflow: hidden;
  &.is-active {
    .content {
      border-top: 1px solid #e4e7ed;
    }
  }
}

.el-collapse-item__header {
  background-color: #f8f9fa;
  padding: 16px 20px;
  font-weight: 500;
  border-bottom: 1px solid #e4e7ed;
}

.el-collapse-item__content {
  background-color: white;
}

/* 修改进度条当前状态颜色为 #409EFF */
::v-deep .el-step__head.is-process .el-step__icon {
  background-color: #409eff !important;
  border-color: #409eff !important;
}

::v-deep .el-step__head.is-process .el-step__icon.is-text {
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: #fff !important;
}

::v-deep .el-step__title.is-process {
  color: #409eff !important;
}

::v-deep .el-step__head.is-process .el-step__line {
  background-color: #409eff !important;
}

::v-deep .el-step__head.is-process .el-step__line-inner {
  background-color: #409eff !important;
}
</style>
